module.exports = __webpack_public_path__ + "static/img/382A4A_5_0.57cb1af.svg";